// Shared full-job API section names and Redux destinations.
export const jobSectionMap = {
  GeneralProjectInfo: "generalProject",
  GeneralStationInfo: "generalStation",
  SoldToShipTo: "soldToShipTo",
  PriceBreakdown: "priceBreakdown",
  OwnersManual: "ownersManual",
  HCRequirements: "hcRequirements",
  SkidConstruction: "skidConstruction",
  PumpManifoldPiping: "pumpManifoldPiping",
  StationEnclosure: "stationEnclosure",
  DropPipeComments: "dropPipeComments",
  DropPipes: "dropPipes",
  LevelControls: "levelControls",
  FillSources: "fillSources",
  PumpParent: "pumps",
  PumpDetails: "pumpDetails",
  WaterTreatmentToggles: "waterTreatment",
  InletScreen: "inletScreen",
  InletStrainer: "inletStrainer",
  DischargeStrainer: "dischargeStrainer",
  DischargeFilter: "dischargeFilter",
  ROSystem: "roSystem",
  UVSystem: "uvSystem",
  Fertigation: "fertigation",
  SkyHarvester: "skyHarvester",
  ShipLoose: "shipLoose",
  UnregulatedPowerSupply: "unregulatedPower",
  UnregulatedBreakers: "unregulatedBreakers",
  RegulatedPowerSupply: "regulatedPower",
  RegulatedBreakers: "regulatedBreakers",
  SequenceOfOperations: "sequenceOfOperations",
  ElectricalOptions: "electricalOptions",
  Telemetry: "telemetry",
  TelemetryAccessories: "telemetryAccessories",
  SelectedPumpOptionList: "selectedPumpOptionList",
  CustomOptions: "customOptions",
  WarningReport: "warningReport",
  ChangedOptions: "changedOptions",
  ControlLogicOnly: "controlLogicOnly",
  ShipEarlyParent: "shipEarlyParent",
  ShipEarlyItems: "shipEarlyItems",
  ChangeOrderParent: "changeOrderParent",
  ChangeOrderDetails: "changeOrderDetails",
};
